module.exports = __webpack_public_path__ + "media/images/banners/1-747c6f8df0c02ca46e342f25abc86ed0.png";